import React from "react";
import { Tooltip, Icon, useBreakpoints } from "@qgiv/core-react";
import { MoreInfoModal } from "../MoreInfoModal";

/**
 * @param {object} props - The component props.
 * @param {string} [props.iconGlyph] - The glyph for the icon.
 * @param {Array<string>} [props.iconClassName] - Additional class names for the icon.
 * @param {string} [props.message] - The message to display in the tooltip.
 * @param {string} [props.mobileMessage] - The message to display in the modal on small screens.
 * @param {string} [props.placement] - The placement of the tooltip.
 * @param {string} [props.position] - The position of the modal.
 * @param {string} [props.tooltipClassName] - Additional class names for the tooltip.
 * @param {string} [props.iconType] - The type of the icon.
 * @param {string} [props.theme] - The theme of the tooltip.
 * @returns {React.ReactElement} The rendered tooltip or modal component.
 */
const Tooltips = ({
    iconGlyph = "question-circle-regular",
    iconClassName = [],
    message = "",
    mobileMessage,
    placement = "right",
    position = "center",
    tooltipClassName = "-type--regular -font-family--font-theme",
    iconType = "FontAwesome",
    theme = "dark",
}) => {
    const { isSmallScreen } = useBreakpoints();

    return isSmallScreen ? (
        <MoreInfoModal position={position}>
            {mobileMessage || message}
        </MoreInfoModal>
    ) : (
        <Tooltip
            placement={placement}
            content={message}
            theme={theme}
            tooltipClassName={tooltipClassName}
        >
            <Icon
                className={iconClassName.join(" ")}
                glyph={iconGlyph}
                type={iconType}
            />
        </Tooltip>
    );
};

export default Tooltips;
